
import Grid from '@mui/material/Grid';
import Typography from '@mui/material/Typography';


export default function Footer(props) {

    return (
        <Grid 
            container 
            direction="column"
            columns={1}
            justifyContent="center"
            alignItems="center">
            <Grid item>
                <Typography variant="caption" textAlign='centrer'>
                    Copyright © 2023 ./peps-dev
                </Typography>
            </Grid>
            <Grid item>
                <Typography variant="caption" textAlign='centrer'>
                    stevry.yushady@gmail.com
                </Typography>
            </Grid>
        </Grid>

    )
}

